module.exports = __webpack_public_path__ + "img/h_mid_2.2b6036b9.png";